"use strict";
// AI Types for Business Idea Generation and Processing
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIErrorCode = void 0;
var AIErrorCode;
(function (AIErrorCode) {
    AIErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    AIErrorCode["RATE_LIMITED"] = "RATE_LIMITED";
    AIErrorCode["INVALID_API_KEY"] = "INVALID_API_KEY";
    AIErrorCode["AUTHENTICATION_ERROR"] = "AUTHENTICATION_ERROR";
    AIErrorCode["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    AIErrorCode["API_UNAVAILABLE"] = "API_UNAVAILABLE";
    AIErrorCode["INVALID_INPUT"] = "INVALID_INPUT";
    AIErrorCode["QUOTA_EXCEEDED"] = "QUOTA_EXCEEDED";
    AIErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    AIErrorCode["GENERATION_FAILED"] = "GENERATION_FAILED";
    AIErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(AIErrorCode = exports.AIErrorCode || (exports.AIErrorCode = {}));
